import { useQuery } from '@tanstack/react-query';
import { queryClient } from 'contexts/QueryClient';
import { useAuth } from 'pages/AuthProvider';

const queryKey = 'companyFeatures';

export default function useCompanyFeatures(companyId?: string) {
  const {
    clients: { company },
  } = useAuth();
  return useQuery({
    queryKey: [queryKey, companyId],
    queryFn: () => {
      if (companyId) {
        return company.getFeatures({ companyId: companyId });
      }
      return null;
    },
  });
}

export const invalidateCompanyFeatures = (companyId: string) => {
  return queryClient.invalidateQueries({ queryKey: [queryKey, companyId] });
};
